import { render, staticRenderFns } from "./automaticMarking.vue?vue&type=template&id=b664725a&scoped=true"
import script from "./automaticMarking.vue?vue&type=script&lang=js"
export * from "./automaticMarking.vue?vue&type=script&lang=js"
import style0 from "./automaticMarking.vue?vue&type=style&index=0&id=b664725a&prod&scoped=true&lang=scss"
import style1 from "./automaticMarking.vue?vue&type=style&index=1&id=b664725a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b664725a",
  null
  
)

export default component.exports